// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__509ck","left":"InfoRow_left__3N_PI"};